import React from 'react';
import useTranslations from '../useTranslations';
import SocialLinks from '../SocialLinks';

import * as S from './styled';

const Footer = () => {
  const {
    aboutProject,
    seeMorePWA,
    maintainedBy,
    contributeMessage,
  } = useTranslations();

  return (
    <S.FooterWrapper>
      <S.FooterContainer>
        <SocialLinks />
        <p>
          © 2014-{new Date().getFullYear()}  {maintainedBy}
        </p>
      </S.FooterContainer>
    </S.FooterWrapper>
  );
};

export default Footer;
